import { createFileRoute } from "@tanstack/react-router";

import { ButtonStyleDebugView } from "~/features/game/components/ButtonStyleDebugView/ButtonStyleDebugView.tsx";

export const Route = createFileRoute("/_auth/dev/buttons")({
    component: ButtonStyleDebugView,
});
